import { Button, Divider, List, Skeleton, Switch, Typography, message } from "antd";
import { useGetEnumeratorProfileInfo } from "api/enumerator/Profile/useGetProfile";
import ErrorPage from "components/ui/ErrorPage";
import { useNavigate } from "react-router-dom";
import { storage } from "utils/storage";
import SettingForm from "./components/SettingForm";
import React from "react";
import { useUpdateEnumeratorProfile } from "api/enumerator/Profile/useUpdateProfile";

const { Title,  } = Typography;


const Settings = () => {

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const [index, setIndex] = React.useState<number | null>(null);

  const navigate = useNavigate();

  const user = storage.getUserFromStorage();

  const { data, error, isFetching } = useGetEnumeratorProfileInfo(user.uid);

  const updateProfileMutation = useUpdateEnumeratorProfile();

  const listData = [
    {
      index: 1,
      title: "Email",
      value: data?.email,
      buttonContent: "Add email",
    },
    {
      index: 2,
      title: "Password",
      value: "You can change your password from here.",
      buttonContent: "Change  password",
    },
    {
      index: 3,
      title: "Phone Number",
      value: data?.phoneNumber,
      buttonContent: "Add number",
    },
  ];

  const notificationListData = [
    {
      title: "Application deadlines",
      value: "Reminders for application deadlines for positions the recruiter has posted.",
    },
  ];

  const handleChange = (checked: boolean) => {
    const payload: any = {
      setting: { notification: { general: { isApplicationReminderEnabled: checked } } },
    };

    if (user?.uid) {
      updateProfileMutation.mutate(
        { id: user.uid, enumerator: payload },
        {
          onSuccess: () => {},
        }
      );
    } else {
      message.error("User id not found");
    }
  };

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <>
      <div className="max-w-6xl mx-auto  my-12 __job__list_container px-5 md:px-0">
        <h1
          className="text-4xl md:text-4xl font-extrabold leading-tighter  mb-4 text-lightGrey"
          data-aos="zoom-y-out"
        >
          Setting
        </h1>

        <div className="my-12">
          <h1
            className="text-3xl md:text-3xl font-semibold leading-tighter  text-lightGrey"
            data-aos="zoom-y-out"
          >
            Account Setting
          </h1>
        </div>

        <List
          className="__applied__jobs"
          loading={isFetching}
          itemLayout="horizontal"
          dataSource={listData}
          renderItem={(item) => (
            <List.Item
              actions={
                item?.value && item.title !== "Password"
                  ? []
                  : [
                      <Button
                        className="h-12 px-4"
                        onClick={() => {
                          if (item?.title === "Password") {
                            navigate("/enumerator/change-password?roleType=Enumerator");
                          } else {
                            setIndex(item?.index);
                            setIsModalOpen(true);
                          }
                        }}
                      >
                        {item?.buttonContent}
                      </Button>,
                    ]
              }
            >
              <Skeleton avatar title={false} loading={isFetching} active>
                <List.Item.Meta
                  title={<Title level={4}>{item?.title}</Title>}
                  description={item?.value}
                />
              </Skeleton>
            </List.Item>
          )}
        />

        <Divider />

        <div className="my-12">
          <h1
            className="text-3xl md:text-3xl font-semibold leading-tighter  text-lightGrey"
            data-aos="zoom-y-out"
          >
            Notification Setting
          </h1>
        </div>

        <List
          className="__applied__jobs"
          loading={isFetching}
          itemLayout="horizontal"
          dataSource={notificationListData}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Switch
                  defaultChecked
                  onChange={handleChange}
                  value={data?.setting?.notification?.general?.isApplicationReminderEnabled}
                  loading={updateProfileMutation.isPending}
                />,
              ]}
            >
              <Skeleton avatar title={false} loading={isFetching} active>
                <List.Item.Meta
                  title={<Title level={4}>{item?.title}</Title>}
                  description={item?.value}
                />
              </Skeleton>
            </List.Item>
          )}
        />
      </div>

      <SettingForm isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} index={index} />
    </>
  );
};

export default Settings;
